import { Distributor } from './distributor';
import { ProductKind } from './product-kind';

export class DistributorProduct
{
	id: number;
	distributor: Distributor;
	product_kind_id: number; //It would be nice to use the productKind object instead of a raw id. Therefore you need the transformers part of Allinn
	name: string;


	constructor()
	{
		this.name = null;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/distributor-product.ts